import CryptoJS from 'crypto-js';

export default (form, public_key) => {
    try {
        let card_expiration = formatCreditCardExpiry(form.card_expiration);
        card_expiration = card_expiration.split("/");
        var card_number = form.card_number.replace(/^(\+)|\D/g, '');
        
        let p = {
            name: form.name,
            document: form.document,
            number: card_number,
            cvv: form.card_cvv,
            month: card_expiration[0],
            year: card_expiration[1]
        };

        var CryptoJsJson = {
            stringify: function(cipherParams) {
                var j = {
                    ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)
                };
                if (cipherParams.iv) j.iv = cipherParams.iv.toString();
                if (cipherParams.salt) j.s = cipherParams.salt.toString();
                return JSON.stringify(j);
            }
        }

        let key = CryptoJS.enc.Utf8.parse(public_key); // Chave como word array
        let iv = CryptoJS.lib.WordArray.random(16); // Vetor de inicialização aleatório

        let encrypted = CryptoJS.AES.encrypt(JSON.stringify(p), key, {
            iv: iv,
            padding: CryptoJS.pad.Pkcs7, // Certifique-se de usar PKCS7
            mode: CryptoJS.mode.CBC,
            format: CryptoJsJson
        }).toString();

        return btoa(encrypted);
    } catch (error) {
        console.log('Erro : ', error);
    }
}

export const formatCreditCardExpiry = (expiry) => {
	expiry = expiry.replace(/\s/g, "");
	console.warn(expiry)
    // Verifica se o formato está correto (MM/YY)
    if (/^\d{2}\/\d{4}$/.test(expiry)) {
        return expiry;
    }

    // Divide a string pelo caractere "/"
    const [month, year] = expiry.split('/');

    // Adiciona "20" na frente do ano para transformar "YY" em "YYYY"
    const fullYear = '20' + year;

    // Retorna o novo formato "MM/YYYY"
    return `${month}/${fullYear}`;
}